import React, { Suspense, useCallback, useMemo } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '@affiliate-cabinet/auth'
import { Grid, Loader, LoaderProgress, MainLayout } from '@affstore-ds/uikit'

import { featuresStatuses } from '../../../config/brands'
import { PAGE_VERTICAL_PADDING } from '../../../shared/constants/spaces'
import { routes } from '../../../shared/routes'
import { OnboardingToOfferConversionFunnel } from '../../../shared/utils'
import { getOfferNavigationLink } from '../../../shared/utils/getOfferNavigationLink'
import { getStartPage } from '../../../shared/utils/getStartPage'
import { HeaderMain } from '../../../widgets'
import { MainLogo } from './base/components/MainLogo'
import { isLocationEqualRoute } from './base/utils'

import { useNavBar } from './base/hooks/useNavbar'

export const Main = () => {
  const {
    auth: { user },
  } = useAuth()

  const location = useLocation()

  const isOnboardingPath = useMemo(() => isLocationEqualRoute(location.pathname, routes.ROUTES_ONBOARDING.onboarding), [location.pathname])
  const navBarProperties = useNavBar(isOnboardingPath)

  const defaultLocation = getStartPage()

  const onLogoClick = useCallback(() => navBarProperties.onLinkClick(defaultLocation), [navBarProperties, defaultLocation])

  if (!isOnboardingPath && user && !user?.is_onboarding_passed) {
    return <Navigate to={routes.ROUTES_ONBOARDING.onboarding} />
  }

  if (isOnboardingPath && user && user?.is_onboarding_passed) {
    if (featuresStatuses.isDashboardPageEnabled) {
      return <Navigate to={defaultLocation} />
    }

    const { COOKIES_PARAMS_OBJECT, getMarketingURLParametersFromCookies } = OnboardingToOfferConversionFunnel
    const onBoardingMarketingCookies = getMarketingURLParametersFromCookies()
    const advertiserAlias = onBoardingMarketingCookies.get(COOKIES_PARAMS_OBJECT.m_oto_advertiser)
    const model = onBoardingMarketingCookies.get(COOKIES_PARAMS_OBJECT.m_oto_model)

    if (advertiserAlias && model) {
      return <Navigate to={getOfferNavigationLink({ active: true, advertiserAlias, model })} />
    }

    return <Navigate to={featuresStatuses.isNewOffersPageEnabled ? routes.ROUTES_OFFERS.offersAdvertisers : routes.ROUTES_ROOT.root} />
  }

  return (
    <MainLayout
      headerProps={{
        content: <HeaderMain />,
        defaultLocation,
        logo: <MainLogo />,
        logoWrapperComponent: 'a',
        onLogoClick,
      }}
      navbarProps={navBarProperties}
    >
      <Grid.Container>
        <Suspense
          fallback={
            <>
              <LoaderProgress loading={true} timeoutInterval={500} isFixed />
              <Loader my={PAGE_VERTICAL_PADDING} />
            </>
          }
        >
          <Outlet />
        </Suspense>
      </Grid.Container>
    </MainLayout>
  )
}
